import React from 'react';
import type { ComponentContentSchema } from '@vibesites/runtime';
// @ts-ignore
import { useContentToken, EditableToken, RichTextContent } from '@vibesites/runtime/react';

export function MissionSection() {
  const label = useContentToken('ctabutton.label');
  const title = useContentToken('ctabutton.title');
  const ctaText = useContentToken('ctabutton.cta_text');
  const ctaUrl = useContentToken('ctabutton.cta_url');
  const bgImage = useContentToken('ctabutton.background_image');

  return (
    <section className="case-mission">
      <div className="case-mission-bg">
        <EditableToken path="ctabutton.background_image" type="image" label="Background Image" defaultValue={contentSchema.tokens['ctabutton.background_image'].defaultValue} as="div"
          style={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        />
      </div>
      <div className="case-mission-content">
        <div style={{ display: 'block' }}>
          <EditableToken path="ctabutton.label" type="text" label="Section Label" defaultValue={contentSchema.tokens['ctabutton.label'].defaultValue} as="p" className="case-mission-label">
            {label}
          </EditableToken>
        </div>
        <div style={{ display: 'block' }}>
          <EditableToken path="ctabutton.title" type="text" label="Title" defaultValue={contentSchema.tokens['ctabutton.title'].defaultValue} as="h2" style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '1.5rem', lineHeight: 1.3 }}>
            {title}
          </EditableToken>
        </div>
        <div style={{ display: 'block' }}>
          <RichTextContent
            path="ctabutton.body"
            label="Body Text"
            defaultValue={contentSchema.tokens['ctabutton.body'].defaultValue}
            as="p"
            style={{ fontSize: '1rem', lineHeight: 1.53, marginBottom: '2rem' }}
          />
        </div>
        <EditableToken path="ctabutton.cta_url" type="url" label="CTA URL" defaultValue={contentSchema.tokens['ctabutton.cta_url'].defaultValue} as="span" style={{ display: 'contents' }}>
          <EditableToken path="ctabutton.cta_text" type="text" label="CTA Button Text" defaultValue={contentSchema.tokens['ctabutton.cta_text'].defaultValue} as="span" style={{ display: 'contents' }}>
            <a className="case-btn" href={ctaUrl}>{ctaText}</a>
          </EditableToken>
        </EditableToken>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'CTAButton',
  displayName: 'Mission Section',
  tokens: {
    'ctabutton.label': {
      label: 'Section Label',
      type: 'text',
      defaultValue: 'OUR MISSION',
    },
    'ctabutton.title': {
      label: 'Title',
      type: 'text',
      defaultValue: 'Caring to improve the lives of our employees and the people we serve',
    },
    'ctabutton.body': {
      label: 'Body Text',
      type: 'richtext',
      defaultValue: 'Case & Associates was the brainchild of Mike Case, who founded the company in 1983 with the idea that property management could be more personable and customer-service oriented.',
    },
    'ctabutton.cta_text': {
      label: 'CTA Button Text',
      type: 'text',
      defaultValue: 'Our Awards',
    },
    'ctabutton.cta_url': {
      label: 'CTA URL',
      type: 'url',
      defaultValue: '/awards/',
    },
    'ctabutton.background_image': {
      label: 'Background Image',
      type: 'image',
      defaultValue: 'https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019d6a03-1b07-7292-8daf-a0d504d9f121.webp',
    },
  },
};

(MissionSection as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default MissionSection;
